<template>
  <v-radio-group
    :hint="hint"
    :hide-details="!hint"
    color="primary"
    persistent-hint
  >
    <client-only> <!-- sometimes the 2nd radio button is unclickable, unless others are clicked -->
      <slot />
    </client-only>
  </v-radio-group>
</template>

<script setup lang="ts">
const props = defineProps<{
  boldLabel?: boolean;
  hint?: string;
}>();
const fontWeight = props.boldLabel ? 500 : 100;
</script>

<style scoped>
:deep(.v-selection-control-group--inline) {
  gap: var(--space-4);
}
:deep(.v-input__control > label) {
  margin-inline-start: 0 !important;
  font-weight: v-bind(fontWeight);
}
</style>